import styled from '@emotion/styled';
import { ClassNames } from '@emotion/react';
import { CSSTransition, SwitchTransition } from 'react-transition-group';

import type { Key } from 'react';
import type { ReactFCWithChildren } from '@widget/types/ReactFCWithChildren';
import type { CSSObject } from '@emotion/serialize';

const SLIDE_DURATION = 250;

export enum AnimationDirection {
  LEFT = 'left',
  RIGHT = 'right',
}

const enterStyles = (direction: AnimationDirection): CSSObject => ({
  position: 'absolute',
  top: 0,
  right: 0,
  left: 0,
  bottom: 0,
  zIndex: 1,
  opacity: 0,
  transform: direction === AnimationDirection.RIGHT ? `translate(50px)` : `translate(-50px)`,
});

const exitStyles = `
  display: none !important;
`;

const enterActive = `
  opacity: 1 !important;
  transform: translateX(0) !important;
  transition: all ${SLIDE_DURATION}ms cubic-bezier(0.4, 0, 0.2, 1);
`;

export const SlideOverWrapper = styled.div`
  width: 100%;
  height: 100%;
  min-height: inherit;
  position: relative;
  display: flex;
  flex-direction: column;
`;

const AnimatedChild = styled.div`
  flex-grow: 1;
  display: flex;
`;

export type SlideOverProps = {
  className?: string;
  transitionKey: Key;
  direction: AnimationDirection;
  appearBg?: string;
};

export const SlideOver: ReactFCWithChildren<SlideOverProps> = ({
  children,
  className,
  transitionKey,
  direction = AnimationDirection.RIGHT,
  appearBg,
}) => {
  return (
    <SlideOverWrapper className={className}>
      <ClassNames>
        {({ css }) => (
          <SwitchTransition mode="in-out">
            <CSSTransition
              key={transitionKey}
              timeout={SLIDE_DURATION}
              classNames={{
                enterActive: css(enterActive),
                enter: css({
                  background: appearBg,
                  ...enterStyles(direction),
                }),
                exit: css(exitStyles),
              }}
            >
              <AnimatedChild>{children}</AnimatedChild>
            </CSSTransition>
          </SwitchTransition>
        )}
      </ClassNames>
    </SlideOverWrapper>
  );
};
